import { PecSwitch, PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { useConfiguracoes } from 'hooks/configuracoes'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'

import { RelatorioGerencialAbsenteismoView } from './absenteismo/RelatorioGerencialAbsenteismoView'
import { RelatorioGerencialAtendimentosProfissionalView } from './atendimentos/RelatorioGerencialAtendimentosProfissionalView'
import { RelatorioGerencialCadastroIndividualView } from './cadastro-individual/RelatorioGerencialCadastroIndividualView'
import { RelatorioGerencialCuidadoCompartilhadoView } from './cuidado-compartilhado/RelatorioGerencialCuidadoCompartilhadoView'
import { RelatorioGerencialExamesView } from './exames/RelatorioGerencialExamesView'
import { RelatorioGerencialVacinacaoView } from './vacinacao/RelatorioGerencialVacinacaoView'

export function RelatoriosGerenciaisRootView() {
  const { path } = useRouteMatch()
  const {
    configuracoes: { rocksdbEnabled },
  } = useConfiguracoes()
  const { PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED } = useFlags()

  return (
    <PecSwitch>
      {rocksdbEnabled && (
        <PrivateRoute path={`${path}/atendimentos`} permission={Permissions.relatorios.gerenciais.atendimentos}>
          <RelatorioGerencialAtendimentosProfissionalView />
        </PrivateRoute>
      )}
      <PrivateRoute path={`${path}/absenteismo`} permission={Permissions.relatorios.gerenciais.absenteismo}>
        <RelatorioGerencialAbsenteismoView />
      </PrivateRoute>
      <PrivateRoute
        path={`${path}/cuidado-compartilhado`}
        permission={Permissions.relatorios.gerenciais.cuidadoCompartilhado}
      >
        <RelatorioGerencialCuidadoCompartilhadoView />
      </PrivateRoute>
      {rocksdbEnabled && (
        <PrivateRoute path={`${path}/vacinacao`} permission={Permissions.relatorios.gerenciais.vacinacao}>
          <RelatorioGerencialVacinacaoView />
        </PrivateRoute>
      )}
      <PrivateRoute path={`${path}/exames`} permission={Permissions.relatorios.gerenciais.exames}>
        <RelatorioGerencialExamesView />
      </PrivateRoute>
      {rocksdbEnabled && PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED && (
        <PrivateRoute
          path={`${path}/cadastro-individual`}
          permission={Permissions.relatorios.gerenciais.cadastroIndividual}
        >
          <RelatorioGerencialCadastroIndividualView />
        </PrivateRoute>
      )}
    </PecSwitch>
  )
}
